<div
  *renderingPermissionDirective="[
    'FirmwareAdmin',
    'FirmwareReader',
    'FirmwareWriter',
    'ModuleUpdateAdmin',
    'ModuleUpdateReader',
    'ModuleUpdateWriter',
  ]"
  class="module-details">
  <div class="module-details__content">
    <dcc-back-button></dcc-back-button>
    <dcc-page-title title="Versions"></dcc-page-title>

    <div class="module-details__container">
      <dcc-module-card-display [module]="this.module"></dcc-module-card-display>

      <div class="module-details__actions">
        <dcc-billboard
          label="Versions"
          [value]="numberOfModuleVersions | number"></dcc-billboard>
        <button
          class="lx-btn-small lx-btn-primary"
          (click)="onModuleVersionCreateClick()">
          Add Version
        </button>
      </div>

      <ag-grid-angular
        class="ag-theme-alpine ag-grid-sticky-header"
        domLayout="autoHeight"
        style="width: 100%; height: 100%"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [enableCellTextSelection]="true"
        [ensureDomOrder]="true"
        [suppressRowHoverHighlight]="true"
        (gridReady)="onGridReady($event)"></ag-grid-angular>
    </div>
  </div>
</div>
